import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../Nav/Navigation.tsx';
import { Footer } from '../Footer/Footer.tsx';

const NotFound: React.FC = () => (
  <>
    <Navigation />
    <main className="nf">
      <p className="code">404 — Page not found</p>
      <h1>That page doesn't exist.</h1>
      <p>Hakuna matata — nothing's broken on your end. The page moved or never was.</p>
      <Link to="/" className="btn solid">Back to the homepage</Link>
    </main>
    <Footer />
  </>
);

export default NotFound;
